<template>
   <a-modal title="添加供求" :visible="visible" width="70%" :confirm-loading="confirmLoading" cancelText="取消" okText="确定"  @ok="handleOk" @cancel="handleCancel">
       <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-row type="flex" justify="space-around" style="width:100%;">
                <a-col :span="12">
                    <a-form-model-item  ref="projectType" label="类型" prop="projectType">
                        <a-select style="width: 100%" v-model="form.projectType"  placeholder="请选择类型" @change="getCategory">
                            <a-select-option v-for="(ele,index) in projectDict[0].bg_project_category" :key="index" :value="ele.dict_value">{{ ele.dict_label }}</a-select-option>
                         </a-select>
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item  ref="projectCategory" label="类别" prop="projectCategory">
                        <a-select :disabled="form.projectType?false:true" style="width: 100%" v-model="form.projectCategory" placeholder="请选择类别">
                            <a-select-option v-for="(ele,index) in projectCategoryList" :key="index" :value="ele.dict_value">{{ ele.dict_label }}</a-select-option>
                         </a-select>
                    </a-form-model-item>
                </a-col>       
            </a-row>
            <a-row type="flex" justify="space-around">
                <a-col :span="24">
                    <a-form-model-item  :label-col="{ span:2 }" :wrapper-col="{ span: 22 }" ref="supplyType" label="供求类型" prop="supplyType">
                        <a-select style="width: 100%" v-model="form.supplyType" placeholder="请选择供求类型">
                            <a-select-option v-for="(ele,index) in projectDict[0].sys_supply_type" :key="index" :value="ele.dict_value">{{ ele.dict_label }}</a-select-option>
                        </a-select>
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row type="flex" justify="space-around">
                <a-col :span="12">
                    <a-form-model-item ref="contact" label="联系人" prop="contact">
                        <a-input v-model="form.contact" placeholder="请输入联系人姓名" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item ref="phone" label="联系方式" prop="phone">
                        <a-input v-model="form.phone" placeholder="请输入联系方式" />
                    </a-form-model-item>
                </a-col>
            </a-row>     
            <!-- <a-row type="flex">
               
            </a-row>     -->
            <a-row type="flex">
                <a-col :span="24">
                    <a-form-model-item :label-col="{ span:2 }" :wrapper-col="{ span: 22 }" ref="descContent" label="文字描述" prop="descContent">
                        <a-input type="textarea" v-model="form.descContent" placeholder="请输入文字描述" />
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row type="flex" justify="space-around">
                <a-col :span="24">
                    <a-form-model-item :label-col="{ span:2 }" :wrapper-col="{ span: 22 }" ref="pictureUrl"  label="图片" prop="pictureUrl">
                        <upload :fileList="fileList" @changeFile="changeFile" @getFile="getFile"  ref="uploadyy"></upload>
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row type="flex" justify="space-around">
                <a-col :span="24">
                    <a-form-model-item :label-col="{ span:2 }" :wrapper-col="{ span: 22 }" label="视频">
                       <uploadVideo :fileList="videoList" @changeFile="changeVideoFile" @getFile="getVideoFile" :id=5 ref="uploadyy"></uploadVideo>
                    </a-form-model-item>
                </a-col>
            </a-row>
       </a-form-model>    
   </a-modal>    
</template>

<script>
import upload from '../../../components/uploadMulty.vue'
import uploadVideo  from '../../../components/uploadVideo.vue'
export default {
    components:{
        upload,
        uploadVideo
    },
    data(){
        return{
            confirmLoading:false,
            visible:false,
            labelCol: { span: 4 },
            wrapperCol: { span: 20 },
            form:{
                supplyId:'',//"主键ID，决定是新增(无)还是编辑(有)",
                projectType:undefined,
                projectCategory:undefined,//:"类别",
                contact:'',//"联系人",
                phone:'',//"联系方式", 
                supplyType:undefined,//"供求类型",
                descContent:'',//"文字描述",
                pictureUrl:'',//"图片地址按逗号分割",
                videoUrl:'',//"视频地址按逗号分割"
            },
            rules:{
                projectCategory:[
                    {
                        required: true,
                        message: "请选择类别",
                        trigger: "change",
                    }
                ],
                projectType:[
                    {
                        required: true,
                        message: "请选择类型",
                        trigger: "change",
                    }
                ],
                contact:[
                    {
                        required: true,
                        message: "请输入联系人姓名",
                        trigger: "blur",
                    }
                ],
                phone:[
                    {
                        required: true,
                        message: "请输入联系人手机号码",
                        trigger: "blur",
                    },
                    {
                        pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
                        message: '请输入正确的手机号',
                        trigger: "blur", 
                    }    
                ],
                supplyType:[
                    {
                        required: true,
                        message: "请选择供求类型",
                        trigger: "change",
                    }
                ],
                descContent:[
                    {
                        required: true,
                        message: "请输入文字描述",
                        trigger: "blur",
                    }
                ],
                pictureUrl:[
                    {
                        required: true,
                        message: "请上传图片",
                        trigger: "blur", 
                    },
                    {
                        validator:this.checkPictureUrl
                    }
                ],
            },
            fileList:[],
            videoList:[],
            projectCategoryList:[]
        }
    },
    props:{
        projectDict:{
            type:Array
        }
    },
    methods:{
        showDiolag(){
            this.visible = true;
        },
        handleOk(){
             this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.confirmLoading = true;
                    this.$https.post('portal/entrust/add',this.form).then(res=>{
                            this.confirmLoading = false;
                            if(res.code == 200){
                                this.$message.success('保存成功');
                                this.$emit('getDataList')
                                this.visible = false;
                                this.clear();
                            }else{
                                this.$message.error(res.msg);
                            }
                    }).catch(error=>{
                        this.confirmLoading = false;
                        this.$error({content:error.msg});
                    })
                }else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        handleCancel(){
            this.visible = false;
        },
         getFile(fileList){
            let arr = [];
                fileList.forEach(item=>{
                    arr.push(item.url)
                })  
            this.form.pictureUrl = arr.join(',');
        },
        changeFile(arr){  //移除file更改fileList
            this.fileList = arr;
            this.form.pictureUrl = arr.join(',');
        },
        getCategory(){
            this.$https.get(`/portal/projectDict/getListByProjectType/${this.form.projectType}`).then(res=>{
                 if(res.code == 200){
                     this.projectCategoryList = res.rows
                 }
            })
        },
        getVideoFile(filelist){
            console.log(filelist)
            let arr = [];
                filelist.forEach(item=>{
                    arr.push(item.url)
                })  
            this.form.videoUrl = arr.join(',');
        },
        checkPictureUrl(rule,value,callback){
            if(this.fileList.length<8){
                callback('至少上传8张图片')
                return
            }
            callback()
        },
        changeVideoFile(arr){
            console.log(arr)
            this.videoList = arr;
            this.form.videoUrl = arr.join(',');
        },
        clear(){
            this.fileList = [];
            this.videoList = [];
            this.form = {
                supplyId:'',//"主键ID，决定是新增(无)还是编辑(有)",
                projectCategory:undefined,//:"类别",
                projectNature:undefined,//"性质",
                contact:'',//"联系人",
                phone:'',//"联系方式", 
                supplyType:undefined,//"供求类型",
                descContent:'',//"文字描述",
                pictureUrl:'',//"图片地址按逗号分割",
                videoUrl:'',//"视频地址按逗号分割"
             }
        }
    }
}
</script>

<style>
.ant-modal-body{
    width: 100%;
}
</style>